import React from 'react';
import { IntegrationCard } from './IntegrationCard';
import fudoLogo from '../../../assets/integrations/fudo.png';
import tiendanubeLogo from '../../../assets/integrations/tiendanube.png';
import woocommerceLogo from '../../../assets/integrations/woocommerce.png';
import { CreditCard, Database } from 'lucide-react';

export const FutureIntegrationsList: React.FC = () => {
    const upcomingIntegrations = [
        {
            name: 'Fudo',
            logo: <img src={fudoLogo} alt="Fudo" className="h-full w-full object-contain" />,
        },
        {
            name: 'Tiendanube',
            logo: <img src={tiendanubeLogo} alt="Tiendanube" className="h-full w-full object-contain" />,
        },
        {
            name: 'WooCommerce',
            logo: <img src={woocommerceLogo} alt="WooCommerce" className="h-full w-full object-contain" />,
        },
        {
            name: 'POS Externos',
            logo: <CreditCard className="h-6 w-6 text-gray-400" />,
        },
        {
            name: 'CRM Externos',
            logo: <Database className="h-6 w-6 text-gray-400" />,
        },
    ];

    return (
        <section className="space-y-6 pt-8 border-t border-gray-100">
            <div className="flex items-center gap-2">
                <h2 className="text-xl font-bold text-gray-400">Próximamente</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                {upcomingIntegrations.map((integration, idx) => (
                    <IntegrationCard
                        key={idx}
                        name={integration.name}
                        description="" // Not used for coming soon
                        status="disconnected" // Not used for coming soon
                        dataPoints={[]} // Not used for coming soon
                        isComingSoon={true}
                        logo={integration.logo}
                    />
                ))}
            </div>
        </section>
    );
};
